import React from 'react';
import { Box, Flex, Image, Text, Link, IconButton } from '@chakra-ui/react';
import { PhoneIcon } from '@chakra-ui/icons';
// import { FaFacebook } from 'react-icons/fa';
import { useBookAppointmentStore } from '../store';

const Footer: React.FC = () => {
  const [clinic] = useBookAppointmentStore((state) => [state.clinic]);

  return (
    <Box
      as="footer"
      bg="gray.100"

      borderTop="1px solid #ddd"
      textAlign="center"
      width="100%"
      mt={10}
    >
      {/* Logo & Clinic Name */}
      <Flex flexDirection="column" alignItems="center" mb={4} p={4}>
        <Image
          src={'/FDPNG.png'}
          //   src={clinic?.icon || '/default-logo.png'} 
          alt={clinic?.location_display_name || 'Clinic Logo'}
          width="150px"
          mb={2}
        />
        <Text fontSize="lg" fontWeight="bold" >
          {clinic?.centre_name}
        </Text>

      </Flex>

      {/* Divider Line */}
      <Box width="100%" borderBottom="1px solid #000" my={4} />


      <Flex
        direction={{ base: "column", md: "row" }}
        align="center"
        justify="center"
        gap={{ base: 2, md: 6 }}
        mb={4}
        pt={3}
      >
        {/* First row for mobile (3 items) */}
        <Flex
          wrap="wrap"
          justify="center"
          gap={4}
          display={{ base: "flex", md: "none" }}
        >
          <Link href={clinic?.website} {...linkStyles}>Home</Link>
          <Link href={`${clinic?.website}/doctors`} {...linkStyles}>Doctors</Link>
          <Link href={`${clinic?.website}/medical-services/`} {...linkStyles}>Medical Services</Link>
        </Flex>

        {/* Second row for mobile (2 items) */}
        <Flex
          wrap="wrap"
          justify="center"
          gap={4}
          display={{ base: "flex", md: "none" }}
        >
          <Link href={`${clinic?.website}/fees`} {...linkStyles}>Fees</Link>
          <Link href={`${clinic?.website}/book`} {...linkStyles} fontWeight="bold" color="red.600">Book Now</Link>
        </Flex>

        {/* Single row layout for md and above */}
        <Flex
          wrap="wrap"
          justify="center"
          gap={6}
          display={{ base: "none", md: "flex" }}
        >
          <Link href={clinic?.website} {...linkStyles}>Home</Link>
          <Link href={`${clinic?.website}/doctors`} {...linkStyles}>Doctors</Link>
          <Link href={`${clinic?.website}/medical-services/`} {...linkStyles}>Medical Services</Link>
          <Link href={`${clinic?.website}/fees`} {...linkStyles}>Fees</Link>
          <Link href={`${clinic?.website}/book`} {...linkStyles} fontWeight="bold" color="red.600">Book Now</Link>
        </Flex>
      </Flex>




      {/* Copyright and Contact Section */}
      <Box as="footer" bg="red.700" color="white" py={4} width="100%" textAlign="center" mt={6}>
        {/* Copyright and Contact Section */}
        <Flex align="center" justify="center" px={8} maxW="1200px" mx="auto">
          <Text fontSize="sm" mr={5}>
            © 2025 <Link href={'https://familydoctor.com.au/'} isExternal textDecoration="underline" color="white">Family Doctor Pty Ltd</Link>. All Rights Reserved.
          </Text>

          {/* Contact Icons */}
          <Flex gap={3}>
            {clinic?.location_phone && (
              <IconButton
                as="a"
                href={`tel:${clinic.location_phone?.replace(/\s+/g, '')}`}
                aria-label="Call Clinic"
                icon={<PhoneIcon />}
                size="sm"
                variant="outline"
                color="white"
              />
            )}

            {/* <IconButton
                        as="a"
                        href={`mailto:${clinic?.email || 'info@familydoctor.com.au'}`}
                        aria-label="Email Clinic"
                        icon={<EmailIcon />}
                        size="sm"
                        variant="ghost"
                        color="white"
                    /> */}

            {/* {clinic?.facebook && (
                        <IconButton
                            as="a"
                            href={clinic.facebook}
                            aria-label="Facebook"
                            icon={<FaFacebook />}
                            size="sm"
                            variant="ghost"
                            color="white"
                            target="_blank"
                        />
                    )} */}
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Footer;

const linkStyles = {
  fontSize: "md",
  fontWeight: "medium",
  color: "gray.700",
  _hover: { textDecoration: "underline" },
  target: "_blank",
  rel: "noopener noreferrer",
};

